<template>
  <Navigation />
  <div class="uk-section uk-section-small">
    <div class="uk-container uk-container-expand">
    <div class="" uk-grid>
      <div class="uk-width-1-3@m">
        <div class="uk-card uk-card-default uk-card-body uk-border-rounded" uk-sticky>
          <h2>Agregar Registro</h2>
          <FormLog />
        </div>
      </div>
      <div class="uk-width-2-3@m" uk-height-viewport="offset-top: true">
        <div class="uk-card uk-card-default uk-border-rounded">
          <div class="home uk-padding">
            <h1>Mis Registros</h1>
            <logs />
          </div>
        </div>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
import Logs from "@/components/Logs.vue";
import FormLog from "@/components/FormLog.vue";
import Navigation from "@/components/Navigation.vue";

export default {
  name: "Home",
  components: {
    Navigation,
    Logs,
    FormLog,
  },
};
</script>
